export default {
  app: {
    title: '妙笔AI管理系统',
  },
  common: {
    confirm: '确定',
    cancel: '取消',
    moreMenus: '更多菜单',
    back: '返回',
    backHome: '回首页',
    returnHome: '返回首页',
    actions: {
      search: '搜索',
      reset: '重置',
      add: '新增',
      addDevice: '新增设备',
      edit: '编辑',
      delete: '删除',
      detail: '详情',
      view: '查看',
    },
    status: {
      enabled: '启用',
      disabled: '禁用',
      online: '在线',
      offline: '离线',
      allocated: '已分配',
      unallocated: '未分配',
    },
    time: {
      createTime: '创建时间',
      updateTime: '修改时间',
      editTime: '编辑时间',
      startTime: '开始时间',
      endTime: '结束时间',
      startDate: '开始日期',
      endDate: '结束日期',
      to: '至',
    },
    form: {
      all: '全部',
      input: '请输入{field}',
      select: '请选择{field}',
      selectFirst: '请先选择{field}',
    },
  },
  language: {
    label: '语言',
    zhCN: '中文',
    enUS: 'English',
  },
  modal: {
    systemPrompt: '系统提示',
    prompt: '提示',
  },
  request: {
    relogin: {
      message: '登录状态已过期，您可以继续留在该页面，或者重新登录',
      confirm: '重新登录',
      expired: '无效的会话，或者会话已过期，请重新登录。',
    },
    network: {
      error: '后端接口连接异常',
      timeout: '系统接口请求超时',
      status: '系统接口{status}异常',
    },
    download: {
      loading: '正在下载数据，请稍候',
      error: '下载文件出现错误，请联系管理员！',
    },
    errors: {
      401: '认证失败，无法访问系统资源',
      403: '当前操作没有权限',
      404: '访问资源不存在',
      default: '系统未知错误，请反馈给管理员',
    },
  },
  login: {
    username: '账号',
    password: '密码',
    captcha: '验证码',
    rememberMe: '记住密码',
    submit: '登 录',
    submitting: '登 录 中...',
    registerNow: '立即注册',
    validation: {
      username: '请输入您的账号',
      password: '请输入您的密码',
      captcha: '请输入验证码',
    },
  },
  register: {
    confirmPassword: '确认密码',
    submit: '注 册',
    submitting: '注 册 中...',
    existingAccount: '使用已有账户登录',
    success: '恭喜你，您的账号 {username} 注册成功！',
    validation: {
      passwordMismatch: '两次输入的密码不一致',
      usernameLength: '用户账号长度必须介于 2 和 20 之间',
      passwordLength: '用户密码长度必须介于 5 和 20 之间',
      invalidChars: '不能包含非法字符：< > " \' \\ |',
      confirmPassword: '请再次输入您的密码',
    },
  },
  welcome: {
    title: '妙笔AI管理平台',
    subtitle: '让创作更简单',
    smartCreation: '智能创作',
    efficientManagement: '高效管理',
    intelligentAnalysis: '智能分析',
  },
  errorPage: {
    401: {
      title: '401错误!',
      headline: '您没有访问权限！',
      description: '对不起，您没有访问权限，请不要进行非法操作！您可以返回主页面',
    },
    404: {
      title: '404错误!',
      headline: '找不到网页！',
      description: '对不起，您正在寻找的页面不存在。尝试检查URL的错误，然后按浏览器上的刷新按钮或尝试在我们的应用程序中找到其他内容。',
    },
  },
  route: {
    aiChat: '神笔马良',
    imageCutDiagram: 'AI抠图',
    aiSchedule: '排课中心',
    home: '首页',
    profile: '个人中心',
    assignRole: '分配角色',
    assignUser: '分配用户',
    dictData: '字典数据',
    jobLog: '调度日志',
    genEdit: '修改生成配置',
    institutionInfo: '机构信息',
  },
  layout: {
    logout: '退出登录',
    logoutConfirm: '确定注销并退出系统吗？',
    settings: {
      themeStyle: '主题风格设置',
      themeColor: '主题颜色',
      layout: '系统布局配置',
      topNav: '开启 TopNav',
      tagsView: '开启 Tags-Views',
      fixedHeader: '固定 Header',
      sidebarLogo: '显示 Logo',
      dynamicTitle: '动态标题',
      save: '保存配置',
      reset: '重置配置',
      saving: '正在保存到本地，请稍候...',
      resetting: '正在清除设置缓存并刷新，请稍候...',
    },
    tagsView: {
      refresh: '刷新页面',
      closeCurrent: '关闭当前',
      closeOthers: '关闭其他',
      closeLeft: '关闭左侧',
      closeRight: '关闭右侧',
      closeAll: '全部关闭',
    },
  },
  equipment: {
    fields: {
      assignedOrg: '分配机构',
      brand: '品牌',
      deviceAssetNo: '设备资产码',
      deviceBrand: '设备品牌',
      deviceImage: '配图',
      deviceModel: '设备型号',
      deviceName: '设备名称',
      deviceSerial: '设备序列号',
      deviceStatus: '设备状态',
      dispatchStatus: '分配状态',
      ipAddress: 'IP地址',
      model: '型号',
      operation: '操作',
      remark: '备注',
      serialNo: '序列号',
    },
    list: {
      sequence: '序号',
      classroomSeat: '教室·座位号',
      dialogAdd: '新增设备',
      dialogEdit: '编辑设备',
      dialogView: '查看设备',
      deleteConfirm: '是否确认删除"{name}"的数据项?',
      deleteWarning: '删除后设备将无法恢复，请谨慎处理。',
      deleteSuccess: '删除成功',
      updateSuccess: '修改成功',
      createSuccess: '新增成功',
      remarkPlaceholder: '请输入备注信息，例如：设备的物理规格、设备配置、配件清单等',
      validation: {
        deviceName: '设备名称不能为空',
        deviceNameLength: '长度在 2 到 20 个字符',
        deviceModel: '设备型号不能为空',
        deviceBrand: '设备品牌不能为空',
        deviceSerial: '设备序列号不能为空',
        deviceStatus: '设备状态不能为空',
        dispatchStatus: '分配状态不能为空',
        assignedOrg: '分配信息不能为空',
        assetNo: '设备资产码不能为空',
        image: '请上传设备配图',
      },
    },
  },
  equipment3d: {
    fields: {
      accessCode: '访问码',
      brand: '品牌',
      connectionStatus: '连接状态',
      deviceBrand: '设备品牌',
      deviceIp: '设备IP',
      deviceIpAddress: '设备IP地址',
      deviceName: '设备名称',
      deviceStatus: '设备状态',
      deviceType: '设备类型',
      ipAddress: 'IP地址',
      model: '型号',
      operation: '操作',
      printSize: '打印尺寸',
      printSizeWithUnit: '打印尺寸(cm)',
      serialNo: '序列号',
      spec1: '规格1',
      spec2: '规格2',
      maxHeight: '最大高度',
    },
    actions: {
      addDevice: '新增设备',
    },
    dialog: {
      addTitle: '新增设备',
      editTitle: '编辑设备',
      subtitle: '不同品牌3D打印机获取方式差异巨大，请联系系统品牌首客进行沟通',
    },
    placeholder: {
      printerName: '3D 打印机的品牌名称',
      printerIp: '3D 打印机的局域网 IP 地址，用于设备通连接',
      accessCode: '3D 打印机的访问权码，用于接口鉴权',
      serialNo: '3D 打印机的设备唯一序列号，用于设备标识',
      numberCm: '请输入数字（单位厘米）',
      maxHeight: '请输入最大高度数字',
    },
    validation: {
      deviceType: '请选择设备类型',
      deviceName: '请输入设备名称',
    },
    message: {
      deleteConfirm: '是否确认删除设备"{name}"？此操作不可恢复！',
      deleteSuccess: '删除成功',
      updateSuccess: '修改成功',
      createSuccess: '新增成功',
    },
  },
}
